import { KeyValuePipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { UniversitySectionLabel } from '@uc/web/shared/data-models';

@Component({
	selector: 'uc-university-section-navigation',
	templateUrl: './university-section-navigation.component.html',
	imports: [NgClass, KeyValuePipe],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UniversitySectionNavigationComponent {
	navigationLabels = input<UniversitySectionLabel>();
	selectedKey = input<string>();
	selectKey = output<string>();

	unsorted() {
		return 0;
	}
}
